import React from 'react';
import { $MaintenanceNotice, $ImgContainer } from './styles';
import maintenance from '../assets/icons/maintenance.svg';
import { Title } from '../';
export const ErrorNotice = ({ message = '' }) => (React.createElement($MaintenanceNotice, null,
    React.createElement($ImgContainer, null,
        React.createElement("img", { src: maintenance, alt: 'error' })),
    React.createElement(Title, { alternate: true }, message)));
